import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Button, {
            'ghost': true,
            'children': 'default'
        }),
        _$cc(Button, {
            'type': 'primary',
            'ghost': true,
            'children': 'primay'
        }),
        _$cc(Button, {
            'type': 'warning',
            'ghost': true,
            'children': 'warning'
        }),
        _$cc(Button, {
            'type': 'danger',
            'ghost': true,
            'children': 'danger'
        }),
        _$cc(Button, {
            'type': 'success',
            'ghost': true,
            'children': 'success'
        }),
        _$cc(Button, {
            'type': 'none',
            'ghost': true,
            'children': 'none'
        }),
        _$cc(Button, {
            'type': 'primary',
            'ghost': true,
            'disabled': true,
            'children': 'primay'
        })
    ], 4, 'wrapper');
};